import React from 'react'
import {Form, Message, Button} from 'semantic-ui-react'
import {createAPIClient} from '../../../services/api'
import {getTemplatesAction} from '../../../actions/template.action'
import {connect} from 'react-redux'
import MemberSelection from './components/memberselection/'
import TemplateSort from './components/templatesort'
const {Field} = Form

class TemplateSettings extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      error: false,
      errorMessage: undefined,
      newForm: {
        location: this.props.locations[0],
        name: '',
        assignee: undefined,
        error: false,
        errorMessage: undefined,
        postSuccess: false
      }
    }
  }
  onFormSubmit () {
    const api = createAPIClient()
    const newForm = this.state.newForm
    newForm.view_index = this.props.templates.length
    api.post('/api/templates/', newForm)
      .then(results => {
        const resetForm = {
          location: this.props.locations[0],
          name: '',
          error: false,
          errorMessage: undefined,
          postSuccess: true
        }
        this.props.getTemplatesAction()
        this.setState({newForm: resetForm})
      })
      .catch(error => {
        newForm['error'] = true
        newForm['errorMessage'] = 'Maximum device count exceeded'
        this.setState({newForm: newForm})
        console.log(error)
      })
  }
  onFieldChange (e) {
    const newForm = this.state.newForm
    newForm[e.target.name] = e.target.value
    this.setState({newForm: newForm})
  }
  render () {
    const form = (
      <div>
        <Form onSubmit={this.onFormSubmit.bind(this)}>
          {this.state.newForm.postSuccess ? (<Message positive>
            <Message.Header>Successfully created new template</Message.Header>
          </Message>) : undefined}

          {this.state.newForm.error ? (<Message negative>
            <Message.Header>{this.state.newForm.errorMessage}</Message.Header>
          </Message>) : undefined}

          <Field>
            <label htmlFor='field_name'>Name*</label>
            <input autoFocus onChange={this.onFieldChange.bind(this)} type='text' id='name' name='name' required value={this.state.newForm.name} />
          </Field>
          {/*<MemberSelection*/}
            {/*onFieldChange={this.onFieldChange.bind(this)}*/}
          {/*/>*/}
          <Button primary type='submit'>Add new form</Button>
        </Form>
      </div>
    )

    return (
      <div>
        <h2>Form</h2>
        {form}
        <br/>
        <TemplateSort />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {...state.customFields, locations: state.account.user.locations, templates: state.templates.templates}
}

export default connect(mapStateToProps, {getTemplatesAction})(TemplateSettings)



// WEBPACK FOOTER //
// ./src/pages/settings/templates/index.js